import type { ReactNode } from "react";

import { useHistory } from "react-router-dom";

import { clsx, Link } from "@alpacahq/ui/old";

type SymbolLinkProps = {
  children?: ReactNode;
  symbol: string;
  underlyingSymbol?: string;
  className?: string;
};

// a clickable symbol component
export const SymbolLink = ({
  symbol,
  underlyingSymbol,
  children,
  className,
}: SymbolLinkProps) => {
  const history = useHistory();

  // handle click event and navigate to symbol page
  const handleClick = () =>
    // navigate to the desired path
    history.push(
      underlyingSymbol
        ? `/trade/${underlyingSymbol}?contract=${symbol}`
        : `/trade/${symbol}`,
    );

  // render symbol component with optional children
  return (
    <div className={clsx("flex flex-row gap-2", className)}>
      <Link onClick={handleClick} className="font-medium">
        {(symbol ?? "").replace("/", "")}
      </Link>
      {children}
    </div>
  );
};
